import EmailIcon from "@mui/icons-material/Email";
import PhoneIcon from "@mui/icons-material/Phone";
import PhoneIphoneIcon from "@mui/icons-material/PhoneIphone";
import LocationCityIcon from "@mui/icons-material/LocationCity";
import MapIcon from "@mui/icons-material/Map";
import PublicIcon from "@mui/icons-material/Public";
import Typography from "@mui/material/Typography";

const BRAND_GREEN = "#648315";

/* ---------- Helper ---------- */

const safeValue = (v) => {
  if (v === null || v === undefined || v === "") return "—";
  if (typeof v === "object") return "—"; // prevent React object render error
  return v;
};

/* ---------- Normalize fields ---------- */

const getDirectPhone = (contact) =>
  contact?.direct_phone_number ||
  contact?.phone ||
  contact?.office_phone ||
  null;

const getMobilePhone = (contact) =>
  contact?.cell_phone_number ||
  contact?.mobile_phone_number ||
  contact?.mobile_phone ||
  null;

const getCity = (contact) => contact?.city || contact?.company?.city || null;

const getState = (contact) =>
  contact?.state ||
  contact?.state_province ||
  contact?.province ||
  contact?.company?.state ||
  null;

const getCountry = (contact) =>
  contact?.country || contact?.company?.country || null;

/* ---------- Profile Config ---------- */

export function contactProfileConfig(contact = {}) {
  const directPhone = getDirectPhone(contact);
  const mobilePhone = getMobilePhone(contact);
  const city = getCity(contact);
  const state = getState(contact);
  const country = getCountry(contact);
  const hasAnyContactInfo = Boolean(contact?.email || directPhone || mobilePhone);

  return [
    {
      title: "Contact Info",
      rows: hasAnyContactInfo
        ? [
            {
              icon: <EmailIcon sx={{ color: BRAND_GREEN }} />,
              label: "Email",
              value: safeValue(contact?.email),
              showIf: Boolean(contact?.email),
            },
            {
              icon: <PhoneIcon sx={{ color: BRAND_GREEN }} />,
              label: "Direct Phone",
              value: safeValue(directPhone),
              showIf: Boolean(directPhone),
            },
            {
              icon: <PhoneIphoneIcon sx={{ color: BRAND_GREEN }} />,
              label: "Mobile Phone",
              value: safeValue(mobilePhone),
              showIf: Boolean(mobilePhone),
            },
          ]
        : [
            {
              icon: null,
              label: "",
              value: (
                <Typography
                  sx={{
                    color: BRAND_GREEN,
                    fontWeight: 700,
                    fontSize: "1.05rem",
                  }}
                >
                  No Contact Info Available
                </Typography>
              ),
              showIf: true,
            },
          ],
    },

    {
      title: "Location",
      rows: [
        {
          icon: <LocationCityIcon sx={{ color: BRAND_GREEN }} />,
          label: "City",
          value: safeValue(city),
          showIf: Boolean(city),
        },
        {
          icon: <MapIcon sx={{ color: BRAND_GREEN }} />,
          label: "State / Province",
          value: safeValue(state),
          showIf: Boolean(state),
        },
        {
          icon: <PublicIcon sx={{ color: BRAND_GREEN }} />,
          label: "Country",
          value: safeValue(country),
          showIf: Boolean(country),
        },
      ],
    },
  ];
}
